import React, { useState, useEffect } from "react";
import HelmetInfo from "Components/HelmetInfo/HelmetInfo";
import { Link } from "react-router-dom";
import { InfinitySpin } from "react-loader-spinner";
import logo from "../../assets/logo.png"; 
import NewsAPI from "../../api/NewsApi";
import BreadCrumb from "./Components/BreadCrumb/BreadCrumb";
import { useTranslation } from "react-i18next";

const News = () => {
  const { t,i18n } = useTranslation('News');
const currentLang = i18n.language || "ar"; 
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("View all");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [pageContent, setPageContent] = useState(null);
  const [categories, setCategories] = useState([]);
  const [newsList, setNewsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchInitialData = async () => {
      setLoading(true);
      try {
        const [newsResponse, typeResponse] = await Promise.all([
          NewsAPI.getNewsData(),
          NewsAPI.getTypeData()
        ]);

        const newsData = newsResponse.data;
        const typeData = typeResponse.data;

        setNewsList(newsData);
        setCategories(["View all", ...typeData.map((type) => type.name)]);
      } catch (err) {
        setError("حدث خطأ أثناء تحميل البيانات.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchInitialData();
  }, []);

  useEffect(() => {
  const fetchPageContent = async () => {
    try {
      const res = await NewsAPI.getPagesNewsData();
      setPageContent(res?.data); 
    } catch (error) {
      console.error("فشل تحميل محتوى صفحة الأخبار", error);
    }
  };

  fetchPageContent();
}, []);


  const handleCategorySelect = async (category) => {
    setSelectedCategory(category);
    setSearchQuery("");

    if (category === "View all") {
      try {
        setLoading(true);
        const newsResponse = await NewsAPI.getNewsData();
        setNewsList(newsResponse.data);
      } catch (err) {
        setError("حدث خطأ أثناء جلب البيانات.");
        console.error(err);
      } finally {
        setLoading(false);
      }
      return;
    }

    try {
      const typeResponse = await NewsAPI.getTypeData();
      const typeData = typeResponse.data;
      const selectedType = typeData.find((type) => type.name === category);

      if (selectedType) {
        const typeId = selectedType.id;
        setLoading(true);
        const newsResponse = await NewsAPI.getNewsTypeData(typeId);
        setNewsList(newsResponse.data);
      }
    } catch (err) {
      setError("حدث خطأ أثناء جلب الأخبار.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const filteredCategories = categories.filter((category) =>
    category.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const filteredNews = Array.isArray(newsList) ? newsList : [];

  return (
    <>
      <HelmetInfo titlePage={"أخبارنا"} />
      <div className="mt-[150px]" />
      <div className="main-container bg-[#fff] mx-auto px-4 py-8 ">
        {/* Header Section */}
        <div className="flex flex-col items-center gap-4 max-w-screen-lg mx-auto">
          {/* Breadcrumb */}
          <BreadCrumb />

          {/* Title Section */}
          <div className="text-center flex items-center flex-col gap-6">
            <span className="text-lg font-medium text-[#0d6b70]"></span>
         {pageContent?.sections?.[0]?.Posts?.[0] && (
            <>
              <h1 className="text-4xl lg:text-[2.75rem] text_bold_Bukra text-[#0d6b70] leading-snug">
                {pageContent.sections[0].Posts[0].title}
              </h1>
              <p className="text-lg lg:text-[1rem] font-medium  w-[85%]  text-[#667680] leading-relaxed">
                {pageContent.sections[0].Posts[0].description}
              </p>
            </>
          )}
          </div>
        </div>
      </div>

      {loading ? (
        // عرض اللودر مع اللوجو أثناء تحميل البيانات
        <div className="flex flex-col justify-center items-center h-screen">
          <img src={logo} alt="Logo" className="w-1/2 mb-4" /> {/* اللوجو */}
          <InfinitySpin
            // @ts-ignore
            visible={true}
            width="200"
            color="#0d6b70"
            ariaLabel="infinity-spin-loading"
          />
        </div>
      ) : (
        <div className="w-[90%] flex flex-col lg:flex-row items-start bg-[#fff] mx-auto px-4 py-16">
          {/* Blog Categories Section */}
          {/* Search Bar */}

          {/* <div className="flex lg:scale-90 flex-col gap-8 w-full lg:w-[35%] md:px-12">
            <div className="relative">
              <input
                type="text"
                value={searchQuery}
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full border border-[#e7e7e7] rounded-[10px] px-4 py-2 bg-white text-[#667680] focus:outline-none"
                placeholder="بحث عن..."
              />
              {isDropdownOpen && (
                <ul className="absolute z-10 bg-white border border-[#e7e7e7] rounded-[10px] w-full mt-2 max-h-48 overflow-y-auto">
                  {filteredCategories.map((category) => (
                    <li
                      key={category}
                      onClick={() => handleCategorySelect(category)}
                      className="px-4 py-2 cursor-pointer hover:bg-[#f4f4f4] text-[#667680] hover:text-[#0d6b70]"
                    >
                      {category}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div className="hidden lg:flex flex-col gap-4">
              <span className="text-[#0d6b70] text-[14px] font-medium">
                Blog Categories
              </span>
              {categories.map((category) => (
                <div
                  key={category}
                  onClick={() => handleCategorySelect(category)}
                  className={`p-1 text_small_Bukra font-semibold cursor-pointer ${
                    selectedCategory === category
                      ? "text-[#0d6b70] border-l-4 border-l-[#0d6b70]"
                      : "text-[#667680]"
                  } hover:text-[#0d6b70] hover:border-l-4 hover:border-l-[#0d6b70]`}
                >
                  {category}
                </div>
              ))}
            </div>
          </div> */}

          {/* News Cards Section */}
          <div className="flex flex-wrap items-start w-full">
            {error ? (
              <p>{error}</p>
            ) : filteredNews.length === 0 ? (
              <p>لا توجد أخبار متاحة.</p>
            ) : (
              filteredNews.map((news, index) => {
                let formattedDate = "تاريخ غير متوفر"; // قيمة افتراضية في حالة عدم توفر التاريخ

          try {
            const dateParts = news.date?.split("-").reverse().join("-");
            if (dateParts) {
              formattedDate = new Date(dateParts).toLocaleDateString(currentLang === "en" ? "en-US" : "ar-EG", {
                day: "numeric",
                month: "long",
                year: "numeric"
              });
            }
          } catch (error) {
            console.error("خطأ في تحويل التاريخ:", error);
          }


                return (
                  <Link
                    key={index}
                    to={`/stats/${news.id}`}
                    className="flex scale-y-95 flex-col gap-4 w-full sm:w-[48%] md:w-[48%] lg:w-[30%] xl:w-[33.3333%] p-3 overflow-hidden group relative"
                  >
                    {/* صورة الخبر */}
                    <div className="rounded-[16px] overflow-hidden">
                      <div
                        className="h-[303px] bg-cover bg-center"
                        style={{
                          backgroundImage: `url(${
                            news.image?.[0]?.original || "default.jpg"
                          })`
                        }}
                      ></div>
                    </div>

                    {/* محتوى الخبر */}
                    <div className="flex flex-col gap-2">
                      <span className="text-[17px] font-semibold text-[#0d6b70]">
                        {news.name}
                      </span>
                    <span className="text-[13px] text-[#667680]">
                      {news.description.length > 50
                        ? `${news.description.slice(0, 50)}...(${t("show_more")})`
                        : news.description}
                    </span>

                      <div className="flex items-center gap-2">
                        <span className="text-[14px] text-[#667680]">
                          {formattedDate}
                        </span>{" "}
                        {/* التاريخ المحول */}
                        <span className="text-[16px] font-medium text-[#e7edf2]">
                          •
                        </span>
                        {/* <span className="text-[16px] font-semibold text-[#0d6b70]">
                {news.type?.name}
              </span>  */}
                      </div>
                    </div>
                  </Link>
                );
              })
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default News;
